import { toDataSourceRequest } from "@progress/kendo-data-query";
import { kvkkClient } from "../client/kvkkClient";
import { reduxErrorThrower } from "../helpers/errorNormalize";
/**
 * @template T
 * @typedef DataSourceResult
 * @prop {T} data
 * @prop {number} total
 * @prop {object} [errors]
 * @prop {Array<any>} [aggregateResults]
 */
/**
 * @typedef DKN_GENEL_KVKK_DOKUMAN_TANIM
 * @prop {number} id
 * @prop {number} componY_CODE
 * @prop {string} dokumaN_KODU
 * @prop {string} dokumaN_TIPI
 * @prop {string} iceriK_TR
 * @prop {string} iceriK_EN
 * @prop {string} basliK_TR
 * @prop {string} basliK_EN
 * @prop {string} dokumaN_ADI_TR
 * @prop {string} dokumaN_ADI_EN
 * @prop {string} versiyon
 * @prop {string} sirA_NO
 */
export default class KvkkService {
  /**
   *
   * @param {string} docCode
   * @returns {Promise<DataSourceResult<DKN_GENEL_KVKK_DOKUMAN_TANIM[]>>}
   */
  static getLastOne(docCode) {
    const params = toDataSourceRequest({
      filter: {
        filters: [
          {
            field: "DOKUMAN_KODU",
            value: docCode.toLowerCase(),
            operator: "eq",
          },
        ],
      },
      sort: [{ field: "VERSIYON", dir: "desc" }],
      take: 2,
    });
    return kvkkClient
      .get("get-list-by-filter", {
        params,
      })
      .then((d) => d.data)
      .catch(reduxErrorThrower);
  }
}
